import React, { Component } from 'react'
import LoginTemplate from 'templates/LoginPage'
import LoginCover from 'organisms/LoginCover'
import PassForgotFormTitled from 'organisms/PassForgotFormTitled'
import { sendForgotPassword } from 'services/authService'
import { censorMail } from 'helpers/txtHelper'
import qs from 'qs'

const srcCover = require('App/assets/images/ic_cover_forgot_pass.png')

class PasswordForgot extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userEmail: '',
      isBtnDisabled: false,
      isEmptyWarning: false,
      isShowForm: true,
      btnLabel: 'Send',
      formTitle: 'Forgot Password?',
      msg: ''
    }

    this.handleMailInput = this.handleMailInput.bind(this)
    this.doSendCall = this.doSendCall.bind(this)
  }

  handleMailInput(value) {
    this.setState({ userEmail: value });
  }

  // method for sending password reset request
  doSendCall(e) {
    e.preventDefault()
    const { userEmail } = this.state
    const data = qs.stringify({
      email: userEmail
    })
    if (userEmail.length) {
      this.setState({
        isEmptyWarning: false,
        isBtnDisabled: true,
        btnLabel: 'Sending...'
      }, async () => {
        try {
          const res = await sendForgotPassword(data)
          if (res.status === 201) {
            const msg = `We’ve sent email to ${censorMail(userEmail)}. Click the link in the email to reset your password.
            \n\n
            If you don’t see the email, check other places it might be, like your junk, spam, social, or other folders.`

            this.setState({
              msg: msg,
              isShowForm: false,
              formTitle: 'Check Your Email'
            })
          }
        } catch (error) {
          const errorResponse = error.response
          if (errorResponse.status === 401) {
            alert(errorResponse.data.message)
            this.setState({
              isEmptyWarning: false,
              isBtnDisabled: false,
              btnLabel: 'Send'
            })
          }
        }
      })
    } else {
      this.setState({ isEmptyWarning: true })
    }
  }

  render() {
    return (
      <LoginTemplate
        leftForm={
          <PassForgotFormTitled
            title={this.state.formTitle}
            fnOnChange={this.handleMailInput}
            fnOnSubmit={this.doSendCall}
            {...this.state}
          />
        }
        cover={<LoginCover coverSrc={srcCover} />}
      />
    );
  }
}

export default PasswordForgot;
